// extracted by mini-css-extract-plugin
module.exports = {"MessageBox":"MessageBox__MessageBox__3CGYK","MessageBox__button":"MessageBox__MessageBox__button__3x8GK"};